import MainLogo from './MainLogo';

export default MainLogo;
